import { Chip, SxProps } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export function StateFundingAcceptedChip({ sx }: { sx?: SxProps }) {
  const { t } = useTranslation("client\\components\\Chips\\FreeForMembersChip");
  return (
    <Chip
      label={t`State funding accepted`}
      size="small"
      sx={[
        theme => ({
          color: theme.palette.neutral.dark,
          backgroundColor: theme.palette.neutral.light,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
